import React from 'react';

import { FlagsProvider } from '@atlaskit/flag';

import { ThirdPartyConfigs } from '../../../../../common/constants/3p-product-configs';
import {
	type ProductKeys,
	ProductKeys3P,
	PRODUCTS_ORDER,
} from '../../../../../common/constants/products';
import { ErrorBoundary } from '../../../../../controllers/error-boundary';
import { useBootstrap, useIsHello } from '../../../../../controllers/store';

import { OAuthBanner } from './oauth-banner';
import { shouldShowOAuthBanner } from './oauth-banner/utils';

const OAuthContainer = () => {
	const [{ outboundAuthConfigs, products: availableProducts }] = useBootstrap();
	const [isHello] = useIsHello();

	let productOrder: ProductKeys[] = [];

	// fg('rovo-full-page-search-3p-static-config') => false
	if (false) {
		const requiredProducts: ProductKeys[] = [];

		ThirdPartyConfigs.forEach((_, productKey3P) => {
			if (ThirdPartyConfigs.get(productKey3P)?.requiresOauth) {
				requiredProducts.push(productKey3P);
			}
		});

		// Filter and order the products based on PRODUCTS_ORDER
		productOrder = PRODUCTS_ORDER.filter((product) => requiredProducts.includes(product));
	} else {
		type ExcludeProductKey = Exclude<keyof typeof ProductKeys3P, 'AtlassianWebCrawler' | 'Loom'>;
		type RequiredProducts = (typeof ProductKeys3P)[ExcludeProductKey][];

		productOrder = [
			ProductKeys3P.GoogleDrive,
			ProductKeys3P.Sharepoint,
			ProductKeys3P.OneDrive,
			ProductKeys3P.Slack,
			ProductKeys3P.Teams,
			ProductKeys3P.Github,
			ProductKeys3P.Figma,
		] as RequiredProducts;
	}
	const productsToBeDisplayed = productOrder.filter((product) =>
		availableProducts.includes(product),
	);

	let displayedProduct;

	for (const product of productsToBeDisplayed) {
		const config = outboundAuthConfigs[product];
		if (config && config.userNeedsOAuth && shouldShowOAuthBanner(product, isHello)) {
			displayedProduct = product;
			break;
		}
	}

	const outboundAuthUrl = displayedProduct && outboundAuthConfigs[displayedProduct]?.url;
	return displayedProduct && outboundAuthUrl ? (
		<FlagsProvider>
			<OAuthBanner product={displayedProduct} outboundAuthUrl={outboundAuthUrl} />
		</FlagsProvider>
	) : null;
};

const OAuthContainerWithErrorBoundary = (): React.JSX.Element => {
	return (
		<ErrorBoundary fallback={null}>
			<OAuthContainer />
		</ErrorBoundary>
	);
};

export default OAuthContainerWithErrorBoundary;
